var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectAll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "selection 1",
    clipPath: "url(#clip0_9454_14884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5996 14.4751H2.84961C1.79961 14.4751 0.974609 13.6501 0.974609 12.6001V2.8501C0.974609 1.8001 1.79961 0.975098 2.84961 0.975098H12.5996C13.6496 0.975098 14.4746 1.8001 14.4746 2.8501V12.6001C14.4746 13.5751 13.5746 14.4751 12.5996 14.4751ZM2.84961 2.4751C2.62461 2.4751 2.47461 2.6251 2.47461 2.8501V12.6001C2.47461 12.8251 2.62461 12.9751 2.84961 12.9751H12.5996C12.8246 12.9751 12.9746 12.8251 12.9746 12.6001V2.8501C12.9746 2.6251 12.8246 2.4751 12.5996 2.4751H2.84961Z",
    fill: "#E6ECF3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5996 17.1001H4.72461C4.27461 17.1001 3.97461 16.8001 3.97461 16.3501C3.97461 15.9001 4.27461 15.6001 4.72461 15.6001H15.5996V4.7251C15.5996 4.2751 15.8996 3.9751 16.3496 3.9751C16.7996 3.9751 17.0996 4.2751 17.0996 4.7251V15.6001C17.0996 16.4251 16.4246 17.1001 15.5996 17.1001Z",
    fill: "#E6ECF3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.97523 10.3502C6.82523 10.3502 6.60023 10.2752 6.45023 10.1252L4.20023 8.0252C3.90023 7.7252 3.90023 7.2752 4.12523 6.9752C4.42523 6.6752 4.87523 6.6752 5.17523 6.9002L6.90023 8.4752L10.1252 5.1752C10.4252 4.8752 10.8752 4.8752 11.1752 5.1752C11.4752 5.4752 11.4752 5.9252 11.1752 6.2252L7.42523 10.0502C7.35023 10.2752 7.12523 10.3502 6.97523 10.3502Z",
    fill: "#E6ECF3"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9454_14884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/selectAll.742cf30c4a3b747b38cfb0278d0d3927.svg";
export { ForwardRef as ReactComponent };